import React, { FunctionComponent, useMemo } from 'react'

import { useTemplateList } from '___hooks'
import { TemplatesAccordionProps } from '.'
import Accordion from 'components/CasusComponents/Accordion'
import { TemplateListItem } from 'components/CasusComponents/Template'

export const TemplatesAccordion: FunctionComponent<TemplatesAccordionProps> = React.memo(({ filter, onClick }) => {
  const {
    list: { isLoading: listIsLoading, isFetching: listIsFetching, data },
    // folders: { isLoading: foldersLoading, isFetching: foldersFetching, error: foldersError, data: folders },
  } = useTemplateList()

  const templates = useMemo(() => {
    return (data || []).map(template => {
      return <TemplateListItem key={`Content-Documents-TemplateListItem-${template.id}`} id={template.id} onClick={onClick} />
    })
  }, [data, onClick])

  return (
    <Accordion isLoading={listIsLoading} isFetching={listIsFetching}>
      {templates}
    </Accordion>
  )
})

TemplatesAccordion.displayName = 'Casus-Components-Accordion-Templates'

export default TemplatesAccordion
